import { useNavigate } from 'react-router-dom-v5-compat';

import InquiryPreview, {
  InquiryPreviewHeader,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryPreview';
import { useSimulateAutoSaveForm } from 'dashboard/apps/InquiryTemplateEditor/InquiryPreview/useSimulateAutoSaveForm';
import { WorkflowVersionMap } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/types';
import { Inquiry } from 'dashboard/models/inquiry';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { InquiryTemplateVersion } from 'dashboard/models/inquiry-template-version';
import { VerificationTemplateVersionStubs } from 'dashboard/models/simulate/stubs';
import { VerificationTemplateVersion } from 'dashboard/models/verification-template-version';
import { FieldValue } from 'lib/fields';
import useToggle from 'lib/hooks/useToggle';

export interface InquiryPreviewForExistingProps {
  inquiry: Inquiry;
  inquiryTemplate: InquiryTemplate;
  inquiryTemplateVersion: InquiryTemplateVersion;
  workflowVersionMap: WorkflowVersionMap;
  verificationTemplateVersions: Record<string, VerificationTemplateVersion>;
  trackEvent: (eventName: string, props?: Record<string, any>) => void;
  handleSaveVerificationTemplateVersionStubs: (
    inquiryId: string,
    verificationTemplateVersionStubs: VerificationTemplateVersionStubs[],
    fieldStubs: Record<string, FieldValue>,
  ) => void;
  handleSkipToStep: (stepName: string, inquiryId: string) => Promise<void>;
  handleViewInquiry: () => void;
  handleLoadInquiry: (inquiryId: string, abortSignal?: AbortSignal) => Promise<void>;
}

export const InquiryPreviewForExisting = ({
  inquiryTemplate,
  inquiryTemplateVersion,
  inquiry,
  workflowVersionMap,
  verificationTemplateVersions,
  trackEvent,
  handleSaveVerificationTemplateVersionStubs,
  handleSkipToStep,
  handleViewInquiry,
  handleLoadInquiry,
}: InquiryPreviewForExistingProps) => {
  const navigate = useNavigate();
  const [isAdvancedMode, { toggle: toggleAdvancedMode }] = useToggle(false);

  const { setValue: simulateFormSetValue, formValues: simulateStubsFormValues } =
    useSimulateAutoSaveForm({
      inquiry: inquiry ?? null,
      verificationTemplateVersions,
      isAdvancedMode,
      handleSaveVerificationTemplateVersionStubs,
    });

  return (
    <>
      <InquiryPreview
        inquiryTemplate={inquiryTemplate}
        inquiryTemplateVersion={inquiryTemplateVersion}
        inquiry={inquiry}
        workflowVersionMap={workflowVersionMap}
        isLoadingInquiry={false}
        verificationTemplateVersions={verificationTemplateVersions}
        isAdvancedMode={isAdvancedMode}
        toggleAdvancedMode={toggleAdvancedMode}
        simulateStubsFormValues={simulateStubsFormValues}
        setSimulateStubsFormValues={simulateFormSetValue}
        trackEvent={trackEvent}
        handleInitializeSimulateInquiry={() => Promise.resolve()}
        handleSkipToStep={handleSkipToStep}
        handleLoadInquiry={handleLoadInquiry}
        header={
          <InquiryPreviewHeader
            inquiryTemplate={inquiryTemplate}
            inquiryTemplateVersion={inquiryTemplateVersion}
            inquiry={inquiry}
            onBackClick={() => navigate(`/dashboard/inquiries/${inquiry.id}`)}
            onViewInquiry={handleViewInquiry}
          />
        }
      />
    </>
  );
};
